import { useCallback, useEffect, useState } from 'react'
import { debounce } from '@utils'

  function useImageDimensions() {
    const [imageDimensions, setImageDimensions] = useState(null)

  const setImageOnPageLOad = useCallback(() => {
    if (typeof document !== 'undefined' && typeof window !== 'undefined') {
      const el = document.getElementById('profile-image')

      if (!el) {
        return
      }

      //calculation for artist profile image as per the different breakpoint and dimensions.
      //@ts-ignore
      let imgWidth = Math.floor(el.clientWidth)
      let imgHeight

      //image aspect ratio based on different breakpoints
      if(window.innerWidth <=767) {
        imgHeight = Math.ceil(imgWidth/0.8)
      }
      if(window.innerWidth <=1023 && window.innerWidth>767) {
        imgHeight = Math.ceil(imgWidth/1.38)
      }

      if(window.innerWidth >= 2560) {
        imgHeight = Math.ceil(imgWidth/1.36) - 10
      }

      if(window.innerWidth >= 1024 && window.innerWidth <2560) {
        imgHeight = Math.ceil(imgWidth/1.47) - 3
      }

      el !== null &&
      //@ts-ignore
      setImageDimensions({ width: imgWidth, height: imgHeight })
    }
  }, [])


  useEffect(() => {
    setImageOnPageLOad()
  }, [setImageOnPageLOad])

  const debouncedHandleResize = debounce(() => {
    setImageOnPageLOad()
  }, 500)

  useEffect(() => {
    window.addEventListener('resize', debouncedHandleResize)
    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  },[debouncedHandleResize])

  return { imageDimensions }

  }

  export default useImageDimensions